import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled from "../styled-components";
export default styled.section(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  flex: 1 0 auto;\n  position: relative;\n"])));